module.exports = __webpack_public_path__ + "media/flags/010-india-65e6b674.svg";